
import SlButton from '@shoelace-style/shoelace/dist/react/button';
import React from 'react';
import { useNavigate } from 'react-router-dom';
const css = `
  .policy-wrapper {
    line-height: 1.65;
    max-width: 900px;
    margin: auto;
    padding: 48px 24px;

    h1 {
      font-size: 2.2rem;
    }

    h2 {
      margin-top: 38px;
    }

    h3 {
      margin-top: 26px;
    }

    .contact {
      padding: 20px;
      border-radius: 8px;
    }
    .app-header {
        text-align: right;
        border-bottom: 1px solid lightgray;
        gap: 17px;
        display: flex;
        flex-direction: column;
        justify-content: end;
    }

    .app-header-left {
        text-align: right;
        gap: 17px;
        display: flex;
        flex-direction: row;
        justify-content: end;
    }
    .app-header-left > img {
        width: 93px;
        margin-bottom: 15px;
    }

    @media screen and (min-width: 900px) {
        .app-header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .app-header-right {
                text-align: right;
                gap: 17px;
                display: flex;
                flex-direction: row;
                justify-content: end;
            }
        }
    }
  }
`;

const Privacy = () => {
  const navigate = useNavigate();
  return (
    <div className="policy-wrapper">
        <header className="app-header">
              <div className="app-header-left">
              <img
                    slot="image"
                    src="./images/LogoSerale.png"
                    alt="JADU."
                  />
              <SlButton variant="primary" onClick={() => navigate('/')}>
                  Home
                </SlButton>
                </div>
        
                <div className="app-header-right">
        
               
                 
                  </div>
              </header>
      <h1>HomeKeepy Privacy Policy</h1>
      <p className="meta">
        <strong>Effective Date:</strong> October 30, 2026
        <br />
        <strong>Last Updated:</strong> October 30, 2026
      </p>
      <p>
        HomeKeepy (&quot;HomeKeepy,&quot; &quot;we,&quot; &quot;us,&quot; or &quot;our&quot;)
        respects your privacy and is committed to protecting the personal information you
        provide when using the HomeKeepy mobile application, website, and related services
        (collectively, the &quot;Services&quot;).
      </p>
      <p>
        This Privacy Policy explains what information we collect, how we use and protect it,
        when we share it with service providers, and the choices you have regarding your
        information.
      </p>
      <p>By using HomeKeepy, you acknowledge the practices described in this Privacy Policy.</p>

      <h2>1. Information We Collect</h2>
      <p>Depending on how you use HomeKeepy, we may collect the following categories of information.</p>

      <h3>A. Account and Contact Information</h3>
      <ul>
        <li>First and last name</li>
        <li>Email address</li>
        <li>Telephone or mobile phone number</li>
        <li>Username or account credentials</li>
        <li>User or account identification numbers</li>
        <li>Property, tenant, owner, or resident information</li>
        <li>Information necessary to authenticate your account</li>
      </ul>
      <p>
        We use this information to create and manage your account, authenticate you,
        communicate with you, and provide the Services.
      </p>

      <h3>B. Property and Home Information</h3>
      <ul>
        <li>Property address</li>
        <li>Unit or property identification information</li>
        <li>Property or appliance information</li>
        <li>Maintenance and repair history</li>
        <li>Service requests</li>
        <li>Property-related notes and descriptions</li>
        <li>Information provided by property owners, managers, tenants, residents, or authorized service providers</li>
      </ul>

      <h3>C. Maintenance Requests and User Content</h3>
      <p>
        When you submit a maintenance request, communicate with a property manager or service
        provider, or use HomeKeepy&apos;s features, we may collect information you provide,
        including:
      </p>
      <ul>
        <li>Maintenance and repair descriptions</li>
        <li>Messages and communications</li>
        <li>Photos and other files you upload</li>
        <li>Documents you choose to provide</li>
        <li>Information about appliances, equipment, or property conditions</li>
        <li>Other content you voluntarily submit through the Services</li>
      </ul>
      <p>
        Please do not submit sensitive personal information unless it is reasonably necessary
        for the maintenance or property-management service you are requesting.
      </p>

      <h3>D. AI Assistant Conversations</h3>
      <p>
        HomeKeepy may provide an AI-powered assistant that helps users with questions relating
        to their property, maintenance, repairs, contracts, and HomeKeepy services.
      </p>
      <p>
        When you interact with the AI assistant, we may collect and process your questions and
        prompts, information included in your messages, relevant property or maintenance
        information necessary to answer your request, AI-generated responses, and related
        technical information necessary to operate the feature.
      </p>
      <p>
        HomeKeepy uses OpenAI services to provide certain AI functionality. Information
        necessary to provide an AI request may be transmitted to OpenAI for processing.
      </p>

      <h3>E. Payment Information</h3>
      <p>
        HomeKeepy accounts are free to create and include a 30-day free trial. Paid HomeKeepy
        subscriptions are purchased and managed exclusively through the HomeKeepy website at{' '}
        <a href="https://www.homekeepy.com">www.homekeepy.com</a>; the iOS application does not
        offer in-app purchases or process subscription payments. If you choose a paid plan, Stripe
        processes the subscription payment and recurring monthly billing. Stripe may process your
        name, email address, billing information, payment card or bank information, transaction
        amount, transaction date, and other information needed to process and verify payment.
      </p>
      <p>
        We may receive and use information about your selected plan, trial or subscription status,
        billing dates, and transaction status or history to administer your account, synchronize
        subscription access across the website and app, provide support, and maintain business and
        financial records. The available monthly plans are HomeKeepy 1–5 Units ($30 per month) and
        HomeKeepy 6–10 Units ($60 per month). Users are not automatically charged when the 30-day
        trial ends; a user must voluntarily purchase a plan through the website to continue with a
        paid subscription.
      </p>
      <p>
        HomeKeepy does not intend to store complete payment card numbers on its own systems
        when payment processing is handled through Stripe.
      </p>

      <h3>F. Phone, Text, and Communications Information</h3>
      <p>
        HomeKeepy may use Twilio to provide certain communication features, including text
        messaging, phone communications, notifications, authentication, or other
        communication services. Depending on the feature used, Twilio may process telephone
        numbers, message content, communication metadata, delivery information, account or
        authentication information, and device and network information associated with
        communications.
      </p>

      <h3>G. Device and Technical Information</h3>
      <p>
        When you use HomeKeepy, we may automatically receive certain technical information,
        such as IP address, device type and model, operating system and version, app version,
        device identifiers, network information, crash and diagnostic information, log
        information, date and time of activity, and general usage information.
      </p>
      <p>
        We use this information to operate, maintain, secure, troubleshoot, and improve
        HomeKeepy.
      </p>

      <h3>H. Customer Support</h3>
      <p>
        If you contact HomeKeepy for assistance, we may collect your name, email address,
        phone number, account information, communications with our support team, and
        information necessary to investigate and resolve your request.
      </p>

      <h2>2. How We Use Information</h2>
      <ul>
        <li>Create and manage user accounts</li>
        <li>Authenticate users</li>
        <li>Provide and operate HomeKeepy</li>
        <li>Manage properties and maintenance requests</li>
        <li>Communicate with tenants, residents, property managers, owners, and service providers</li>
        <li>Process payments and transactions</li>
        <li>Provide AI-powered assistance</li>
        <li>Send service-related notifications and communications</li>
        <li>Send text messages or other communications when authorized</li>
        <li>Respond to customer-support requests</li>
        <li>Maintain and improve the Services</li>
        <li>Detect, prevent, and investigate fraud, abuse, unauthorized access, and security incidents</li>
        <li>Troubleshoot technical problems</li>
        <li>Comply with legal and regulatory requirements</li>
        <li>Enforce our terms and policies</li>
        <li>Protect the rights, safety, and property of HomeKeepy and its users</li>
      </ul>
      <p>
        We do not use personal information for purposes that are incompatible with the
        purposes described in this Privacy Policy unless permitted or required by law or with
        your consent where required.
      </p>

      <h2>3. How We Share Information</h2>
      <h3>Service Providers</h3>
      <p>
        We may share information with trusted third-party companies that provide services
        necessary to operate HomeKeepy, including <strong>OpenAI</strong> for AI-powered
        functionality, <strong>Stripe</strong> for payment processing, <strong>Twilio</strong>
        for SMS, telephone, authentication, and communications services, and cloud hosting,
        database, security, infrastructure, technical, customer-support, and communication
        providers.
      </p>
      <p>
        These providers are permitted to process information as necessary to provide services
        to HomeKeepy and are subject to applicable contractual and legal obligations.
      </p>

      <h3>Property Owners and Managers</h3>
      <p>
        If you use HomeKeepy as a tenant, resident, or other property user, information
        relating to your account, property, and maintenance requests may be shared with the
        property owner, property manager, landlord, authorized representative, or service
        provider when necessary to provide property-management or maintenance services.
      </p>

      <h3>Service Providers and Contractors</h3>
      <p>
        Information necessary to complete a maintenance or repair request may be shared with
        authorized contractors, technicians, vendors, or other service providers.
      </p>

      <h3>Legal and Safety Requirements</h3>
      <p>
        We may disclose information when reasonably necessary to comply with applicable law,
        regulation, legal process, or governmental request; protect the rights or safety of
        HomeKeepy, our users, or others; detect or investigate fraud, security issues, or
        illegal activity; or enforce our agreements and policies.
      </p>

      <h3>Business Transfers</h3>
      <p>
        If HomeKeepy is involved in a merger, acquisition, financing, reorganization, sale of
        assets, bankruptcy, or similar transaction, personal information may be transferred as
        part of that transaction, subject to applicable law.
      </p>

      <h2>4. Artificial Intelligence</h2>
      <p>
        Certain HomeKeepy features use artificial intelligence services provided by OpenAI.
        Information submitted to AI-powered features may be transmitted to OpenAI to generate
        responses and provide the requested functionality. Users should avoid submitting
        unnecessary sensitive information through AI features.
      </p>
      <p>
        HomeKeepy does not represent that AI-generated information is always accurate,
        complete, or appropriate for every situation. AI-generated responses are provided for
        informational and service-support purposes and should not be relied upon as
        professional advice.
      </p>

      <h2>5. Payments</h2>
      <p>
        HomeKeepy uses Stripe for certain payment-processing services. When you initiate a
        payment, you may be redirected to or interact with Stripe&apos;s payment infrastructure.
        Stripe may collect and process payment and transaction information necessary to
        complete the transaction.
      </p>
      <p>
        HomeKeepy does not intentionally collect or store complete payment card information on
        its own systems when that information is processed directly by Stripe.
      </p>

      <h2>6. Text Messages and Communications</h2>
      <p>
        If you provide a telephone number and authorize HomeKeepy to communicate with you by
        text message, HomeKeepy may send service-related messages such as maintenance-request
        updates, account notifications, verification codes, appointment or service
        notifications, and property-related communications. Message frequency may vary.
      </p>
      <p>
        You may be able to opt out of certain text communications by following the
        instructions included in the message or by contacting HomeKeepy. Opting out of certain
        communications may affect your ability to receive important service or account
        notifications.
      </p>

      <h2>7. Data Retention</h2>
      <p>
        We retain personal information for as long as reasonably necessary to provide the
        Services, maintain user accounts, maintain property and maintenance records, complete
        transactions, resolve disputes, maintain security, comply with legal, accounting, tax,
        or regulatory obligations, and enforce our agreements.
      </p>
      <p>
        Retention periods may vary depending on the type of information and the purpose for
        which it was collected. When personal information is no longer reasonably necessary for
        these purposes, we may delete, de-identify, or securely dispose of it, subject to
        applicable legal requirements. Third-party service providers may maintain information
        according to their own contractual and legal retention requirements.
      </p>

      <h2>8. Account Deletion and Your Privacy Choices</h2>
      <p>
        You can initiate permanent deletion of your HomeKeepy account from Account settings
        in the app. We verify the request using your account password. Deletion removes your
        account and associated account data, subject to applicable legal retention obligations.
      </p>
      <p>
        When you request deletion, we may need to verify your identity before completing the
        request. Some information may be retained when necessary to comply with legal
        obligations, resolve disputes, prevent fraud or abuse, maintain security, or satisfy
        legitimate business or regulatory requirements.
      </p>

      <h2>9. California Privacy Rights</h2>
      <p>
        If you are a California resident, you may have rights under the California Consumer
        Privacy Act (CCPA), as amended, including applicable rights to know about personal
        information collected about you; request access to certain personal information;
        request deletion, subject to applicable exceptions; request correction of inaccurate
        personal information; opt out of certain sales or sharing where applicable; limit
        certain uses of sensitive personal information where applicable; and not receive
        discriminatory treatment for exercising applicable privacy rights.
      </p>
      <p>HomeKeepy does not sell personal information for monetary consideration.</p>
      <p>
        To exercise applicable privacy rights, contact us at{' '}
        <a href="mailto:admin@homekeepy.com">admin@homekeepy.com</a>. We may need to
        verify your identity before processing a privacy request.
      </p>

      <h2>10. Children&apos;s Privacy</h2>
      <p>
        HomeKeepy is intended for adults and is not directed to children under 13. We do not
        knowingly collect personal information directly from children under 13. If we learn
        that we have collected personal information from a child under 13 without appropriate
        authorization, we will take reasonable steps to delete the information.
      </p>
      <p>
        If you believe a child has provided personal information to HomeKeepy, please contact
        us at <a href="mailto:admin@homekeepy.com">admin@homekeepy.com</a>.
      </p>

      <h2>11. Data Security</h2>
      <p>
        We use reasonable administrative, technical, and organizational safeguards designed to
        protect personal information against unauthorized access, disclosure, alteration,
        destruction, or loss. These measures may include encryption of information in transit,
        access controls, authentication mechanisms, secure hosting and infrastructure,
        monitoring and security controls, and vendor security practices.
      </p>
      <p>
        No method of electronic transmission or storage is completely secure, and we cannot
        guarantee absolute security.
      </p>

      <h2>12. International Data Processing</h2>
      <p>
        HomeKeepy and our service providers may process or store information in the United
        States and other jurisdictions where our service providers operate. When required by
        applicable law, we take reasonable steps to provide appropriate protections for
        personal information transferred across jurisdictions.
      </p>

      <h2>13. Third-Party Services</h2>
      <p>
        <strong>OpenAI</strong> — Used for certain AI-powered features and processing of AI
        requests.
      </p>
      <p>
        <strong>Stripe</strong> — Used for payment processing and related transaction services.
      </p>
      <p>
        <strong>Twilio</strong> — Used for certain SMS, telephone, authentication, and
        communication functionality.
      </p>
      <p>
        These companies may process information in accordance with their respective privacy
        policies and service agreements.
      </p>

      <h2>14. Links to Third-Party Websites</h2>
      <p>
        HomeKeepy may contain links to websites or services operated by third parties. We are
        not responsible for the privacy practices, security, or content of third-party
        websites. We encourage you to review the privacy policies of any third-party service
        you access.
      </p>

      <h2>15. Cookies and Similar Technologies</h2>
      <p>
        Our website may use cookies, pixels, local storage, or similar technologies to operate
        the website, maintain security, remember preferences, understand website usage, and
        improve our Services.
      </p>
      <p>
        The HomeKeepy mobile application may also use technologies necessary for
        authentication, security, diagnostics, and functionality. The specific technologies
        used may change as HomeKeepy develops.
      </p>

      <h2>16. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time to reflect changes in our
        Services, technology, business practices, legal requirements, or privacy practices.
        When we make changes, we will update the &quot;Last Updated&quot; date at the top of this
        Privacy Policy. If we make material changes, we may provide additional notice where
        required by applicable law.
      </p>

      <h2>17. Contact Us</h2>
      <div className="contact">
        <p>
          <strong>HomeKeepy</strong>
        </p>
        <p>
          Website: <a href="https://www.homekeepy.com">https://www.homekeepy.com</a>
        </p>
        <p>
          Privacy inquiries: <a href="mailto:admin@homekeepy.com">admin@homekeepy.com</a>
        </p>
      </div>

      <p>
        <strong>Last Updated: October 30, 2026</strong>
      </p>

      <style>{css}</style>
    </div>
  );
};

export default Privacy;
